<template>
  <b-button
    v-if="isVisible"
    variant="primary"
    class="back-to-top"
    @click="$emit('scrollToTop')"
  >
    <b-icon icon="arrow-up" />
  </b-button>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped>
.back-to-top {
  position: fixed;
  bottom: 20px;
  right: 40px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  transition: opacity 0.3s, visibility 0.3s;
}
</style>
